import {getTodayStartTime, daysBetween} from 'shared/utils/dateTime';

export function isDateChanged(lastRecalcDateTime: LastRecalcDateTime): boolean {
  const daysPassed = daysBetween(getTodayStartTime(), lastRecalcDateTime);
  return daysPassed > 0;
}
